/**
 * Azure DevOps OAuth resource (app) id — the fixed audience every delegated scope is issued for.
 * It is the same for all tenants; only the scope names that follow it are configurable.
 * @see https://learn.microsoft.com/en-us/azure/devops/integrate/get-started/authentication/oauth#available-scopes
 */
export const AZURE_DEVOPS_RESOURCE_ID = '499b84ac-1321-427f-aa17-267ca6975798';

/**
 * Default Azure DevOps OAuth scope name requested when neither central config nor the
 * `VITE_AZURE_SCOPES` env var overrides it. `.default` requests every delegated permission the
 * Entra app registration has already been consented for — the safe, always-valid choice. A tenant
 * that needs granular permissions can override with explicit names (e.g. `vso.work_write`) via
 * central config `AZURE_SCOPES`.
 * @see https://learn.microsoft.com/en-us/azure/devops/integrate/get-started/authentication/oauth#available-scopes
 */
export const DEFAULT_AZURE_SCOPE_NAMES = ['.default'] as const;

/** Qualify a bare Azure DevOps scope name (e.g. `vso.work_write`) with the resource id. */
export const toAzureScopeUri = (scopeName: string): string =>
	`${AZURE_DEVOPS_RESOURCE_ID}/${scopeName}`;
